import { createSelector } from 'reselect';
import { matchPath } from 'react-router';

export const routerSelector = (state) => state.get('router');

export const locationSelector = createSelector(routerSelector, (router) =>
  router.get('location')
);

export const projectIdSelector = createSelector(
  locationSelector,
  (location) => {
    const pathName = location.get('pathname');
    const match = matchPath(pathName, {
      path: '/projects/:projectId'
    });

    if (match) {
      return match.params.projectId;
    }
    return '';
  }
);
export const groupIdSelector = createSelector(locationSelector, (location) => {
  const pathName = location.get('pathname');
  const match = matchPath(pathName, {
    path: '/projects/:projectId/groups/:groupId'
  });
  if (match) {
    return +match.params.groupId;
  }
  return '';
});
